import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_INCIDENT } from "../../../utils/constants";
import { IncidentInterface } from "../../../models/Incident";
import incidentService from "../../../services/incidentService";

const useIncidentById = (id: string | undefined) =>
  useQuery<IncidentInterface, Error>({
    queryKey: [`${CACHE_KEY_INCIDENT}ById`, id],
    queryFn: ({ queryKey }) => {
      const [, incidentId] = queryKey;
      return incidentService.GetById(incidentId as string);
    },
    enabled: !!id, // Only run the query if id is truthy (not undefined or an empty string)
  });

export default useIncidentById;
